// extracted by mini-css-extract-plugin
module.exports = {"o1vaqllh":"o1vaqllh","c142omxx":"c142omxx","s1gb9soz":"s1gb9soz","s11scz11":"s11scz11","sva3ab2":"sva3ab2"};